module.exports = __webpack_public_path__ + "img/protect_your_privacy.884fc408.jpg";